import type { MessageKey } from '../message-keys';
import type { MessageTemplate } from '../types';
import { EN_MESSAGES } from './en';

export const RU_MESSAGES = {
  ...EN_MESSAGES,
  'app.tagline': 'ДЕТЕРМИНИРОВАННЫЕ СРАЖЕНИЯ',
  'app.debug': 'ОТЛАДКА',
  'app.arenaLabel': 'Игровая арена',
  'app.bot': 'БОТ',
  'app.next': 'ДАЛЕЕ',
  'app.nextCard': 'Следующая карта',
  'app.hand': 'Карты в руке',
  'app.brandDescription': 'Один движок. Стратегия в реальном времени. Проверяемые повторы.',
  'app.pause': 'ПАУЗА',
  'app.resume': 'ПРОДОЛЖИТЬ',
  'app.settings': 'НАСТРОЙКИ',
  'app.engineVersion': 'ENGINE {engineVersion} · {count} КАРТ',
  'start.title': 'КОРОЛЕВСКИЙ БОЙ С НУЛЯ',
  'start.description': 'Собери две независимые колоды по 8 карт из общего каталога.',
  'profile.label': 'ИМЯ ИГРОКА',
  'profile.placeholder': 'Игрок',
  'profile.aria': 'Имя игрока',
  'deck.builder': 'Конструктор колод',
  'deck.mine': 'МОЯ КОЛОДА',
  'deck.bot': 'КОЛОДА БОТА',
  'deck.titleMine': 'МОЯ КОЛОДА · {count}/8',
  'deck.titleBot': 'КОЛОДА БОТА · {count}/8',
  'deck.average': 'Средний эликсир {value}',
  'deck.slots': 'Восемь слотов колоды',
  'deck.slot': 'Слот {slot}: {card}',
  'deck.catalog': 'ОБЩИЙ КАТАЛОГ',
  'deck.catalogAria': 'Каталог карт',
  'deck.reset': 'СБРОСИТЬ',
  'deck.cardAria': '{card}, {cost} эликсира{selected}',
  'deck.alreadySelected': ', уже в колоде',
  'bot.configuration': 'Настройка искусственного интеллекта',
  'bot.variant': 'Вариант бота',
  'bot.learningLoading': 'Обучение: загрузка…',
  'bot.modelPreparing': 'Подготовка модели',
  'bot.resetLearning': 'СБРОСИТЬ ОБУЧЕНИЕ БОТА',
  'bot.learning': 'Обучение: {count} боёв · уверенность {confidence}%',
  'bot.learningOff': 'Обучение отключено для этого варианта бота',
  'bot.lastDeck': ' · последняя колода: {deck}',
  'bot.modelCurrent': 'Текущая модель: {style} · hash {hash}{lastDeck}',
  'bot.modelEmpty': 'Истории пока нет — будет использована ручная колода',
  'bot.classicPolicy': 'Колода и решения используют классическую детерминированную policy{lastDeck}',
  'bot.classic': 'Классический',
  'bot.adaptive': 'Адаптивный контрбот',
  'bot.learningReset': 'Обучение бота сброшено',
  'bot.learningResetFailed': 'Не удалось сбросить обучение: {error}',
  'bot.modelRepaired': 'Модель обучения бота была несовместима и сброшена',
  'bot.learningUnavailable': 'Обучение бота недоступно: {error}',
  'bot.preferenceRepaired': 'Неизвестный вариант бота заменён адаптивным',
  'style.balanced': 'сбалансированный',
  'style.aggression': 'агрессивный',
  'style.cycle': 'цикличный',
  'style.beatdown': 'тяжёлый пуш',
  'style.airPressure': 'воздушное давление',
  'style.swarm': 'рой',
  'style.spellControl': 'контроль заклинаниями',
  'style.defense': 'защитный',
  'start.playBot': 'ИГРАТЬ ПРОТИВ БОТА',
  'start.loadingArena': 'ЗАГРУЗКА АРЕНЫ…',
  'start.lastBattle': 'ПОСЛЕДНИЙ БОЙ И ЛОГ',
  'start.settingsLogs': 'НАСТРОЙКИ И ЛОГИ',
  'start.controls': 'Мышь / касание · клавиши 1–4 · Esc отмена · Space пауза',
  'network.title': 'СЕТЕВАЯ ИГРА 1×1',
  'network.description': 'Создай приватную комнату или войди по коду. Оба игрока запускают один детерминированный движок.',
  'network.create': 'СОЗДАТЬ КОМНАТУ',
  'network.join': 'ВОЙТИ В КОМНАТУ',
  'network.codePlaceholder': 'КОД КОМНАТЫ',
  'network.codeAria': 'Код комнаты',
  'network.cancel': 'ОТМЕНА',
  'network.copyCode': 'КОПИРОВАТЬ КОД',
  'network.copyInvite': 'СКОПИРОВАТЬ ССЫЛКУ',
  'network.acceptInvite': 'ПРИНЯТЬ ВЫЗОВ',
  'network.leaderboard': 'ТАБЛИЦА ДРУЖЕСКИХ ИГР',
  'network.waiting': 'Ожидание соперника…',
  'network.connecting': 'Соединяем игроков…',
  'network.ready': 'Соперник подключён. Запускаем бой…',
  'network.cancelled': 'Комната закрыта. Можно создать новое приглашение.',
  'network.connectionTimeout': 'Соперник принял приглашение, но браузеры не смогли установить P2P-соединение. Комната закрыта — создай новое приглашение и попробуй ещё раз.',
  'network.unavailable': 'Сетевая игра недоступна: {error}',
  'network.roomCreated': 'Комната {code} создана. Передай код сопернику.',
  'network.joining': 'Входим в комнату {code}…',
  'network.codeCopied': 'Код комнаты скопирован',
  'network.inviteCopied': 'Приватная ссылка приглашения скопирована',
  'network.acceptingInvite': 'Принимаем вызов…',
  'network.invitedBy': '{name} вызывает тебя на приватный бой 1×1',
  'network.hostRating': 'У соперника {wins} побед в {games} сетевых играх',
  'network.headToHead': 'Личные встречи: соперник {hostWins} · ты {guestWins} · ничьи {draws}',
  'network.inviteUnavailable': 'Приглашение недействительно, истекло или уже использовано.',
  'network.copyFailed': 'Не удалось скопировать код комнаты',
  'network.disconnected': 'Соединение с соперником потеряно',
  'network.reconnecting': 'Связь прервана. Переподключаемся…',
  'network.reconnected': 'P2P-соединение восстановлено',
  'network.connectionLost': 'Не удалось восстановить связь с соперником. Бой закрыт — можно создать новую комнату.',
  'network.emotes': 'Боевые эмоции',
  'network.waitingLockstep': 'Ожидание команды соперника…',
  'network.claimPending': 'Результат ожидает подтверждения соперника',
  'network.claimConfirmed': 'Результат подтверждён обоими игроками',
  'network.claimServerVerified': 'Результат проверен серверным повтором',
  'network.claimDisputed': 'Результаты игроков различаются; победа не засчитана',
  'network.casualNotice': 'Дружеские P2P-результаты подтверждают два игрока; это не защищённый рейтинг.',
  'network.rankLine': '{rank}. {name} — {wins} В / {losses} П / {draws} Н',
  'result.victory': 'ПОБЕДА',
  'result.defeat': 'ПОРАЖЕНИЕ',
  'result.draw': 'НИЧЬЯ',
  'result.replayLabel': 'ПОВТОР · {label}',
  'result.kingDestroyed': 'КОРОЛЬ ПОВЕРЖЕН',
  'result.overtimeVictory': 'БОЙ ЗАВЕРШЁН В ОВЕРТАЙМЕ',
  'result.tiebreak': 'ТАЙБРЕЙК',
  'result.finished': 'БОЙ ЗАВЕРШЁН',
  'result.summary': '{own}:{opponent} · {seconds} сек · checksum {checksum}',
  'result.noChecksum': 'нет',
  'result.diagnostics': '{records} записей · {critical} critical · {errors} errors · {warnings} warnings',
  'result.finding': '[{ruleId}] тик {tick}',
  'result.noFindings': 'Нарушения не обнаружены',
  'result.analyzer': 'ПОСЛЕМАТЧЕВЫЙ АНАЛИЗ',
  'result.again': 'ЕЩЁ РАЗ',
  'result.replay': 'ПОВТОР',
  'result.export': 'ЭКСПОРТ ЛОГА',
  'result.home': 'НА ГЛАВНУЮ',
  'result.deleteLog': 'УДАЛИТЬ ЛОГ',
  'result.noResult': 'Сохранённый бой не содержит результата',
  'result.confirmAgain': 'НАЖМИ ЕЩЁ РАЗ',
  'result.logDeleted': 'ЛОГ УДАЛЁН',
  'result.logDeleteFailed': 'ОШИБКА УДАЛЕНИЯ',
  'result.logDeletedToast': 'Лог этого боя удалён',
  'result.logDeleteError': 'Не удалось удалить лог: {error}',
  'settings.title': 'НАСТРОЙКИ',
  'settings.music': 'Музыка',
  'settings.effects': 'Эффекты',
  'settings.quality': 'Качество',
  'settings.qualityAuto': 'Авто',
  'settings.qualityLow': 'Низкое',
  'settings.qualityHigh': 'Высокое',
  'settings.mute': 'Без звука',
  'settings.reducedMotion': 'Уменьшить движение',
  'settings.language': 'Язык',
  'settings.privacy': 'АНАЛИТИКА И ПРИВАТНОСТЬ',
  'settings.metrics': 'Отправлять анонимные игровые метрики',
  'settings.metricsHelp': 'Посещения, активное время, число боёв, retention и агрегированное использование карт. Без полного журнала боя.',
  'settings.logs': 'Загружать полные логи завершённых и аварийных боёв',
  'settings.logsHelp': 'Включено по умолчанию. Локальная диагностика сохраняется всегда; настройка управляет отправкой на сервер.',
  'settings.deleteServerLogs': 'УДАЛИТЬ МОИ ЗАГРУЖЕННЫЕ ЛОГИ',
  'settings.clearLogs': 'СТЕРЕТЬ СОХРАНЁННЫЕ ЛОГИ',
  'settings.done': 'ГОТОВО',
  'settings.savedFailed': 'Настройки применены, но браузер не смог их сохранить',
  'settings.logsEnabled': 'Полные логи завершённых и аварийных боёв будут отправляться на сервер',
  'settings.logsDisabled': 'Отправка на сервер отключена; локальная диагностика остаётся активной',
  'settings.deleteServerConfirm': 'НАЖМИ ЕЩЁ РАЗ ДЛЯ УДАЛЕНИЯ',
  'settings.serverLogsDeleted': 'ЗАГРУЖЕННЫЕ ЛОГИ УДАЛЕНЫ',
  'settings.serverLogsMissing': 'НА СЕРВЕРЕ НЕТ МОИХ ЛОГОВ',
  'settings.serverLogsDeletedToast': 'Загруженные полные логи удалены с сервера',
  'settings.serverLogsMissingToast': 'Загруженные логи не найдены',
  'settings.serverDeleteFailed': 'ОШИБКА УДАЛЕНИЯ',
  'settings.serverDeleteError': 'Не удалось удалить серверные логи: {error}',
  'settings.clearConfirm': 'НАЖМИ ЕЩЁ РАЗ ДЛЯ ОЧИСТКИ',
  'settings.logsCleared': 'ЛОГИ УДАЛЕНЫ',
  'settings.logsClearCurrent': 'История очищена; текущий бой будет сохранён после завершения',
  'settings.logsClearDone': 'Сохранённые логи удалены',
  'settings.logsClearFailed': 'ОШИБКА ОЧИСТКИ',
  'settings.logsClearError': 'Не удалось удалить логи: {error}',
  'hud.preparation': 'ПОДГОТОВКА',
  'hud.regulation': 'ОСНОВНОЕ ВРЕМЯ{multiplier}',
  'hud.overtime': 'ОВЕРТАЙМ ×{multiplier}',
  'hud.ended': 'ЗАВЕРШЕНО',
  'command.insufficient-elixir': 'Недостаточно эликсира',
  'command.card-cooldown': 'Карта ещё не готова',
  'command.invalid-position': 'Нельзя разместить здесь',
  'command.card-not-in-hand': 'Карты уже нет в руке',
  'command.invalid-sequence': 'Команда уже отправлена',
  'command.late-command': 'Команда опоздала',
  'command.future-command': 'Команда слишком ранняя',
  'command.unknown-card': 'Неизвестная карта',
  'command.battle-ended': 'Бой уже завершён',
  'command.invalid-command': 'Некорректная команда',
  'toast.playerSaveFailed': 'Имя применено, но браузер не смог его сохранить',
  'toast.deckSaveFailed': 'Колоды применены, но браузер не смог их сохранить',
  'toast.botSaveFailed': 'Режим бота применён, но браузер не смог его сохранить',
  'toast.startFailed': 'Не удалось запустить бой: {error}',
  'toast.logSaveFailed': 'Лог не сохранён: {error}',
  'toast.deckRepaired': 'Сохранённая колода была повреждена или устарела — восстановлены стандартные 8 карт',
  'toast.appUpdated': 'Игра обновлена — нажмите REPLAY ещё раз',
  'card.giant.name': 'Гигант',
  'card.knight.name': 'Рыцарь',
  'card.musketeer.name': 'Мушкетёр',
  'card.bomber.name': 'Бомбер',
  'card.skeletons.name': 'Скелеты',
  'card.minions.name': 'Миньоны',
  'card.cannon.name': 'Пушка',
  'card.fireball.name': 'Огненный шар',
  'card.giant-skeleton.name': 'Гигантский скелет',
  'card.goblin-barrel.name': 'Бочка с гоблинами',
  'card.goblin-gang.name': 'Банда гоблинов',
  'card.mega-knight.name': 'Мегарыцарь',
  'card.minion-horde.name': 'Орда миньонов',
  'card.the-log.name': 'Бревно',
  'card.witch.name': 'Ведьма',
  'card.wizard.name': 'Волшебник',
  'arena.basecamp.name': 'Базовый лагерь',
} satisfies Record<MessageKey, MessageTemplate>;
